import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { styled } from "@mui/material/styles";
import { ColoredSwitch } from "@/components/ui/BlueSwitch";

const Circle = styled("div")(({ theme, active, color }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 20,
  height: 20,
  borderRadius: "50%",
  backgroundColor: active ? color : theme.palette.background.default,
  boxShadow: theme.shadows[2],
  color: active ? "#ffffff" : color,
}));

const ThumbIcon = ({ checked, color }) => (
  <Circle active={checked} color={color}>
    {checked ? (
      <VisibilityIcon sx={{ fontSize: 14 }} />
    ) : (
      <VisibilityOffIcon sx={{ fontSize: 14 }} />
    )}
  </Circle>
);

export default function VisibilitySwitch(props) {
  const color = "#004f7d";

  return (
    <ColoredSwitch
      {...props}
      color={color}
      icon={<ThumbIcon checked={false} color={color} />}
      checkedIcon={<ThumbIcon checked color={color} />}
    />
  );
}
